import { environment } from '@env/environment';

export const USERS_LIMIT = environment.production ? 10 : 6;
